export const calculators = [
  {
    id: "income-tax",
    name: "Income Tax Estimator",
    title: "Income Tax Estimator",
    description: "Calculate your federal income tax liability based on your income, filing status, and deductions",
    icon: "ri-calculator-line",
    color: "from-blue-600 to-purple-600",
    featured: true
  },
  {
    id: "deduction-finder",
    name: "Deduction Finder",
    title: "Deduction Finder",
    description: "Discover all eligible tax deductions for your situation",
    icon: "ri-search-line",
    color: "bg-emerald-50",
    textColor: "text-emerald-900"
  },
  {
    id: "refund",
    name: "Refund Calculator",
    title: "Refund Calculator",
    description: "Estimate your tax refund or amount owed",
    icon: "ri-money-dollar-circle-line",
    color: "bg-orange-50",
    textColor: "text-orange-900"
  },
  {
    id: "w2-vs-1099",
    name: "W-2 vs 1099 Comparison",
    title: "W-2 vs 1099 Comparison",
    description: "Compare employee and contractor tax implications",
    icon: "ri-file-compare-line",
    color: "bg-white border border-gray-200",
    textColor: "text-gray-900"
  },
  {
    id: "self-employment",
    name: "Self-Employment Tax",
    title: "Self-Employment Tax",
    description: "Calculate self-employment tax for freelancers and contractors",
    icon: "ri-briefcase-line",
    color: "bg-blue-50",
    textColor: "text-blue-900"
  },
  {
    id: "capital-gains",
    name: "Capital Gains Calculator",
    title: "Capital Gains Calculator",
    description: "Estimate taxes on investment sales and capital gains",
    icon: "ri-stock-line",
    color: "bg-purple-50",
    textColor: "text-purple-900"
  },
  {
    id: "quarterly-tax",
    name: "Quarterly Tax Estimator",
    title: "Quarterly Tax Estimator",
    description: "Calculate estimated quarterly tax payments",
    icon: "ri-calendar-check-line",
    color: "bg-teal-50",
    textColor: "text-teal-900"
  },
  {
    id: "withholding",
    name: "Withholding Calculator",
    title: "Withholding Calculator",
    description: "Determine correct W-4 withholding allowances",
    icon: "ri-percent-line",
    color: "bg-indigo-50",
    textColor: "text-indigo-900"
  },
  {
    id: "retirement",
    name: "Retirement Contribution",
    title: "Retirement Contribution",
    description: "Calculate optimal IRA and 401(k) contributions",
    icon: "ri-funds-line",
    color: "bg-rose-50",
    textColor: "text-rose-900"
  },
  {
    id: "state-comparison",
    name: "State Tax Comparison",
    title: "State Tax Comparison",
    description: "Compare state tax burdens across all 50 states",
    icon: "ri-map-pin-line",
    color: "bg-amber-50",
    textColor: "text-amber-900"
  }
];